import { useHistory } from 'react-router';
import useTranslation from '../../../../hooks/useTranslations';
import { BreadcrumbIcon } from '../../../misc/icons/Icons';

const Breadcrumb = ({ activeTree, customTree }) => {
	const history = useHistory();
	const t = useTranslation();

	return (
		<div className="flex py-2 pl-4 pr-8 mb-3 text-white text-[1.0625rem]">
			<button
				type="button"
				// TODO: Go Back in Breadcrumb instead of history
				onClick={() => history.goBack()}
				className="flex flex-shrink-0 h-full mr-2 can-hover:hover:text-oly-gray-lightest focus-visible:text-oly-gray-lightest focus:outline-none"
				aria-labelledby="go-back"
			>
				<BreadcrumbIcon className="w-6 h-6" />
			</button>
			<div className="min-h-13">
				<BreadcrumbLink route="/" title={t('tab_main')} />

				{activeTree?.businessArea && (
					<>
						{' / '}
						<BreadcrumbLink route={`/${activeTree.businessArea.id}`} title={t(activeTree.businessArea.translationkey)} />
					</>
				)}

				{activeTree?.businessArea && activeTree?.folder1 && (
					<>
						{' / '}
						{activeTree.folder1.group_label ? `${t(activeTree.folder1.group_label)} / ${t(activeTree.folder1.translationkey)}` : `${t(activeTree.folder1.translationkey)}`}
					</>
				)}

				{activeTree?.businessArea && activeTree?.folder1 && activeTree?.folder2 && (
					<>
						{' / '}
						<BreadcrumbLink route={`/${activeTree.businessArea.id}/${activeTree.folder1.id}/${activeTree.folder2.id}`} title={t(activeTree.folder2.translationkey)} />
					</>
				)}

				{activeTree?.businessArea && activeTree?.folder1 && activeTree?.folder2 && activeTree?.folder3 && (
					<>
						{' / '}
						<BreadcrumbLink route={`/${activeTree.businessArea.id}/${activeTree.folder1.id}/${activeTree.folder2.id}/${activeTree.folder3.id}`} title={t(activeTree.folder3.translationkey)} />
					</>
				)}

				{customTree?.length > 0 && customTree.map((element) => (
					<span key={element.route}>
						{' / '}
						<BreadcrumbLink route={`/${element.route}`} title={t(element.translationKey)} />
					</span>
				))}
			</div>


		</div>
	);
};

export default Breadcrumb;

const BreadcrumbLink = ({ route, title }) => {
	const history = useHistory();

	const pushRoute = (e) => {
		e.preventDefault();
		history.push(route);
	};

	return (
		<a
			href={route}
			className="underline can-hover:hover:text-oly-gray-lightest focus-visible:text-oly-gray-lightest focus:outline-none"
			onClick={(e) => pushRoute(e)}
		>
			{title}
		</a>
	);
};
